'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // FEED MANAGEMENT
    .state('pages.main.manage_feeds', {
        url: '/manage_feeds',
        template: require('../views/feeds/manage_feeds.html'),
        controller: 'manageFeedController',
        controllerAs: 'page',
        data: {
            title: 'Feed Management',
            daterange: false
        }
    })
}


/** WEBPACK FOOTER **
 ** ./src/pages/routes/feed.js
 **/